<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <app-contact :contactPageData='contactPage'></app-contact>
        <app-footer></app-footer>
    </div>
</template>

<script> 


    import {listContactUrl, configs} from '../../config';
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import FrontFooter from '@/components/partials/FrontFooter';
    import EventBus from '../event-bus';
    import ListContactComponent from "@/components/contact/ListContactComponent";
    import SessioMixin from '../../mixins/sessionmixin';

    Vue.use(VueGoodTable);

    export default {
        name: "listContact",
        mixins: [SessioMixin],
        components: {
            'app-contact': ListContactComponent,
            'app-footer': FrontFooter,
        },
        data: () => ({
                contactPage: {
                    pageTitle: 'Contact List',
                    perPage: 25,
                    cus_id: 0,
                    is_part: 0,
                },
                loginID: 0,
                isLoggedIn: false,
            }),

        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menucontacts").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            this.showLoader();
            // this.loadContacts();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                // app.getPermissions();
            }
        },
        methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }

        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/contact/ListContacts.vue